import React from 'react';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-600 to-purple-700 flex items-center justify-center">
      <div className="text-center text-white">
        <div className="w-16 h-16 mx-auto mb-4">
          <svg className="animate-pulse" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
        </div>
        <h1 className="text-2xl font-bold mb-2">Driftslogg Sandbox Beta</h1>
        <p className="text-blue-100 mb-4">Dockerless Operations Management</p>
        <div className="loading-spinner w-8 h-8 border-2 border-white border-t-transparent rounded-full mx-auto"></div>
        <p className="text-sm text-blue-200 mt-4">Initializing demo environment...</p>
      </div>
    </div>
  );
}